// extracted by mini-css-extract-plugin
export default {"App":"App_App__7BBxi","mainpage":"App_mainpage__24Sa9","mobil":"App_mobil__6nHpX","mobilLogo":"App_mobilLogo__lah94","logoText":"App_logoText__yB762"};